/**
 * Cloud Storage naming shared by the app and its cloud functions.
 *
 * Both sides derive the same bucket names and public URLs from these values, so
 * a terraform rename lands in one place instead of once per side.
 *
 * Kept dependency-free on purpose — prepareFilterCode.sh copies this file
 * verbatim into functions/node/src/common/types, so any import would have to
 * resolve from both locations.
 */

/**
 * Prefix terraform provisions every radarview EU app bucket under: the names
 * are `<prefix>_<env>_<suffix>`, where env is the environment resolver's value
 * (dev/stg/pro). Verified against the three projects on 2026-07-27 — fully
 * derivable, so no per-bucket env vars.
 */
export const BUCKET_NAME_PREFIX = 'radarview_eu'

/**
 * Suffix of each terraform-provisioned bucket. Snake_case, unlike the
 * kebab-case bucket ids the signed-URL endpoint takes over the wire.
 */
export enum BucketSuffix {
  Aida = 'aida',
  CustomGeoboundaries = 'custom_geoboundaries',
  PoiIcons = 'poi_icons',
}

/**
 * Origin for public reads, used path-style (`<origin>/<bucket>/<object>`).
 * These bucket names contain underscores, which the virtual-hosted form
 * (`<bucket>.storage.googleapis.com`) cannot represent, so only path style works.
 */
export const PUBLIC_OBJECT_URL_ORIGIN = 'https://storage.googleapis.com'
